export default __webpack_public_path__ + "static/media/title_mob.92025c1b.svg";